/**
 * "New starters: 2 need your action" — a quiet link where people already look
 * (My tickets, the support rail), shown only when there is something to do.
 *
 * Reads `/starters` only for someone `/auth/me` says has a case, so nobody
 * else pays for the read.
 */

import { ChevronRight, Icon, UserPlus } from "@norican/icons";
import { cn } from "@norican/react";
import { Link } from "react-router";

import { useT } from "@/i18n";
import { useMe } from "@/lib/api";

import { useStarterCases } from "./api";

export interface StarterActionLinkProps {
  className?: string;
}

export function StarterActionLink({ className }: StarterActionLinkProps) {
  const { t } = useT("tickets");
  const { data: me } = useMe();
  // 28 Oct (Rusty): not on the new forms; the access cases carry the actions.
  const on = me?.has_starter_cases === true && me.access_new_forms !== true;
  const query = useStarterCases({ enabled: on });
  const count = on ? (query.data?.action_count ?? 0) : 0;
  if (count === 0) {
    return null;
  }
  return (
    <Link
      to="/starters"
      className={cn(
        "group text-accent-fg-subtle flex min-w-0 items-center gap-2 rounded-md text-sm font-medium underline-offset-2 hover:underline",
        className,
      )}
    >
      <Icon icon={UserPlus} size="sm" tone="accent" />
      <span className="min-w-0 flex-1">{t("starters.needAction", { count })}</span>
      <Icon icon={ChevronRight} size="sm" className="shrink-0" />
    </Link>
  );
}
